import Vue from 'vue'
import App from './App.vue'
import vuetify from '@/plugins/vuetify'
import Tracking from './plugins/Tracking.js'
import routes from './routes'
import VueRouter from 'vue-router'
import TextHighlight from 'vue-text-highlight'
import i18n from './locales'
import '@/styles/main.scss'
import config from './config'
import VueSnip from 'vue-snip'

Vue.component('text-highlight', TextHighlight)

window.Office.onReady()
  .then(() => {
    Vue.config.productionTip = false
    console.log(`Using config URL as ${config.self}`)

    Vue.use(VueRouter)
    Vue.use(Tracking)
    Vue.use(VueSnip)

    console.log('Office Loaded')
    const router = new VueRouter({
      routes,
    })

    new Vue({
      vuetify,
      router,
      i18n,
      render: h => h(App),
    }).$mount('#app')
  })
  .catch(err => {
    console.log('Error while loading Office', err)
  })
